import { useEffect } from "react";

export default function Landingpage() {
  useEffect(() => {
    window.location.href = process.env.REACT_APP_LANDING_PAGE_URL;
  }, []);
  return null;
}
